/**
 * Main <App /> React component of this boilerplate.
 * It's purpose is to render a Router with initialized
 * history to the Redux state.
 */

import React, { Component } from 'react';
import cx from 'classnames';

import Loader from './Loader';
import Header from './Header';
import Description from './Description';
import ItemList from './ItemList';
import ErrorMessage from './ErrorMessage';
import ErrorTypes from 'constants/ErrorTypes';
import DataSource from 'sources/DataSource';

class App extends Component {
    constructor(props) {
        super(props);

        this.submitAnswers = this.submitAnswers.bind(this);
        this.state = {
            data: null,
            error: null,
            submitting: false,
            submitted: false
        };
    }

    componentDidMount() {
        // example url http://localhost:8000/#5
        const href = window.location.href;
        const idString = href.substring(href.lastIndexOf('/')).match(/\d+/);
        let id = NaN;
        if (idString != null) {
            id = parseInt(idString[0], 10);
        }
        if (isNaN(id)) {
            this.setState({
                error: {
                    type: ErrorTypes.ERROR_ID
                }
            });
        } else {
            DataSource.getData(id, (data) => {
                this.setState({
                    data: data.data
                });
            }, (error) => {
                this.setState({
                    error: error.error
                });
            });
        }
    }

    submitAnswers(answers) {
        this.setState({
            submitting: true
        });

        DataSource.submitData(this.state.data.id, answers,
            (_success) => {
                this.setState({
                    submitting: false,
                    submitted: true
                });
            },
            (error) => {
                this.setState({
                    submitting: false,
                    error: error.error
                });
            }
        );
    }

    render() {
        const brand = this.state.data ? this.state.data.data.brand : 'default';
        switch (brand) {
            case 'protherm': document.title = 'Protherm – hodnotenie'; break;
            case 'vaillant': document.title = 'Vaillant – hodnotenie'; break;
            default: break;
        }

        const containerClasses = cx({
            main: true,
            message: this.state.error || this.state.submitted,
            protherm: brand === 'protherm',
            vaillant: brand === 'vaillant'
        });

        if (this.state.error) {
            return (
                <div className={containerClasses}>
                    <ErrorMessage
                        type={this.state.error.type}
                        description={this.state.error.description}
                    />
                </div>
            );
        } else if (this.state.data && !this.state.submitted) {
            const formData = this.state.data.data;
            return (
                <div className={containerClasses}>
                    <Header brand={formData.brand}>
                        <p>
                            Radi by sme poznali Váš názor na služby servisných technikov.<br />
                            Ohodnoťte prosím servisnú aktivitu na Vašom zariadení.<br />
                            Vaše hodnotenie je anonymné, bude započítané do priemeru.
                        </p>
                    </Header>
                    <Description
                        model={formData.model}
                        brand={formData.brand}
                    />
                    <ItemList
                        items={formData.questions}
                        onSubmit={this.submitAnswers}
                        brand={formData.brand}
                        submitting={this.state.submitting}
                    />
                </div>
            );
        } else if (this.state.submitted) {
            return (
                <div className={containerClasses}>
                    <Header brand={brand} >
                        <p>
                            Ďakujeme za hodnotenie, pomáhate nám zvyšovať kvalitu<br />
                            našich služieb.
                        </p>
                    </Header>
                </div>
            );
        } else {
            return (
                <Loader />
            );
        }
    }
}

App.propTypes = {};
App.defaultProps = {};
App.contextTypes = {};

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/